import { render } from "./4HubunganIndustrialdanPerlindunganTenagaKerja.vue?vue&type=template&id=0521ed8a&scoped=true"
import script from "./4HubunganIndustrialdanPerlindunganTenagaKerja.vue?vue&type=script&lang=js"
export * from "./4HubunganIndustrialdanPerlindunganTenagaKerja.vue?vue&type=script&lang=js"

import "./4HubunganIndustrialdanPerlindunganTenagaKerja.vue?vue&type=style&index=0&id=0521ed8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0521ed8a"]])

export default __exports__